import React from 'react';
import { Switch } from 'react-router-dom';
import LoadableRoute from '../components/features/share/loadable/loadableRoute';
import { PrivateRoute, PublicRoute, DeviceRoute } from './routePermission';

//Layout
const LayoutMaster = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutMaster')
});
const LayoutBlank = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutBlank')
});
const LayoutPD = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutPD')
});
const LayoutLogin = LoadableRoute({
    loader: () => import('../components/layout/controllers/LayoutLogin')
});

//Features
//Auth
const NotFoundController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/NotFoundController')
});
const UnAuthenController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/UnAuthenController')
});

// Home

const LoginController = LoadableRoute({
    loader: () => import('../components/features/login/controllers/loginController')
});

const AmthLoginController = LoadableRoute({
    loader: () => import('../components/features/amthLogin/controllers/amthLoginController')
});

const LoginManageDomainController = LoadableRoute({
    loader: () => import('../components/features/login/controllers/loginBackendController')
});
// Domain
const DomainController = LoadableRoute({
    loader: () => import('../components/features/manageDomain/controllers/domainListController')
});
const DomainCreateController = LoadableRoute({
    loader: () => import('../components/features/manageDomain/controllers/domainCreateController')
});
const DomainUpdateController = LoadableRoute({
    loader: () => import('../components/features/manageDomain/controllers/domainUpdateController')
});
const DomainViewController = LoadableRoute({
    loader: () => import('../components/features/manageDomain/controllers/domainViewController')
});

export default () => (
    <Switch>
        <PrivateRoute path="/domain/create" component={DomainCreateController} layout={LayoutBlank} onGoingJob={true} />
        <PrivateRoute path="/domain/update/:id" component={DomainUpdateController} layout={LayoutBlank} onGoingJob={true} />
        <PrivateRoute path="/domain/view/:id" component={DomainViewController} layout={LayoutBlank} onGoingJob={true} />
        <PrivateRoute path="/domain/list" component={DomainController} layout={LayoutBlank} />

        <PublicRoute path="/amth/:redirectUrl" component={AmthLoginController} layout={LayoutLogin} />
        <PublicRoute path="/amth" component={AmthLoginController} layout={LayoutLogin} />
        <PublicRoute path="/login" component={LoginController} layout={LayoutLogin} />
        <PublicRoute path="/manageDomainLogin" component={LoginManageDomainController} layout={LayoutLogin} />
        <PublicRoute path="/unauthen" component={UnAuthenController} layout={LayoutLogin} />
        <PublicRoute path="/" component={LoginManageDomainController} layout={LayoutLogin} />
        <PublicRoute component={NotFoundController} layout={LayoutMaster} />
    </Switch>
);



// WEBPACK FOOTER //
// ./src/app/routes/Routes.js